export const MASTER_TRAYEK_LIST_URL = 'master_trayek/list'
export const MASTER_TRAYEK_LIST_ERROR = 'MASTER_TRAYEK_LIST_ERROR'
export const MASTER_TRAYEK_LIST_LOADING = 'MASTER_TRAYEK_LIST_LOADING'
export const MASTER_TRAYEK_LIST_SUCCESS = 'MASTER_TRAYEK_LIST_SUCCESS'

export const MASTER_TRAYEK_PAGE_URL = 'master_trayek/page'
export const MASTER_TRAYEK_PAGE_ERROR = 'MASTER_TRAYEK_PAGE_ERROR'
export const MASTER_TRAYEK_PAGE_LOADING = 'MASTER_TRAYEK_PAGE_LOADING'
export const MASTER_TRAYEK_PAGE_SUCCESS = 'MASTER_TRAYEK_PAGE_SUCCESS'

export const MASTER_TRAYEK_VIEW_URL = 'master_trayek/view'
export const MASTER_TRAYEK_VIEW_ERROR = 'MASTER_TRAYEK_VIEW_ERROR'
export const MASTER_TRAYEK_VIEW_LOADING = 'MASTER_TRAYEK_VIEW_LOADING'
export const MASTER_TRAYEK_VIEW_SUCCESS = 'MASTER_TRAYEK_VIEW_SUCCESS'

export const MASTER_TRAYEK_ADD_URL = 'master_trayek/save'
export const MASTER_TRAYEK_ADD_ERROR = 'MASTER_TRAYEK_ADD_ERROR'
export const MASTER_TRAYEK_ADD_LOADING = 'MASTER_TRAYEK_ADD_LOADING'
export const MASTER_TRAYEK_ADD_SUCCESS = 'MASTER_TRAYEK_ADD_SUCCESS'

export const MASTER_TRAYEK_DELETE_URL = 'master_trayek/delete'
export const MASTER_TRAYEK_DELETE_ERROR = 'MASTER_TRAYEK_DELETE_ERROR'
export const MASTER_TRAYEK_DELETE_LOADING = 'MASTER_TRAYEK_DELETE_LOADING'
export const MASTER_TRAYEK_DELETE_SUCCESS = 'MASTER_TRAYEK_DELETE_SUCCESS'

export const MASTER_TRAYEK_UPDATE_URL = 'master_trayek/update'
export const MASTER_TRAYEK_UPDATE_ERROR = 'MASTER_TRAYEK_UPDATE_ERROR'
export const MASTER_TRAYEK_UPDATE_LOADING = 'MASTER_TRAYEK_UPDATE_LOADING'
export const MASTER_TRAYEK_UPDATE_SUCCESS = 'MASTER_TRAYEK_UPDATE_SUCCESS'

export const MASTER_TRAYEK_DELETE_TRAYEK_URL = 'master_trayek/delete_trayek'
export const MASTER_TRAYEK_DELETE_TRAYEK_ERROR = 'MASTER_TRAYEK_DELETE_TRAYEK_ERROR'
export const MASTER_TRAYEK_DELETE_TRAYEK_LOADING = 'MASTER_TRAYEK_DELETE_TRAYEK_LOADING'
export const MASTER_TRAYEK_DELETE_TRAYEK_SUCCESS = 'MASTER_TRAYEK_DELETE_TRAYEK_SUCCESS'

export const MASTER_TRAYEK_ADD_TRAYEK_URL = 'master_trayek/add_trayek'
export const MASTER_TRAYEK_ADD_TRAYEK_ERROR = 'MASTER_TRAYEK_ADD_TRAYEK_ERROR'
export const MASTER_TRAYEK_ADD_TRAYEK_LOADING = 'MASTER_TRAYEK_ADD_TRAYEK_LOADING'
export const MASTER_TRAYEK_ADD_TRAYEK_SUCCESS = 'MASTER_TRAYEK_ADD_TRAYEK_SUCCESS'

export const MASTER_TRAYEK_UPDATE_RATES_URL = 'master_trayek/update_rates'
export const MASTER_TRAYEK_UPDATE_RATES_ERROR = 'MASTER_TRAYEK_UPDATE_RATES_ERROR'
export const MASTER_TRAYEK_UPDATE_RATES_LOADING = 'MASTER_TRAYEK_UPDATE_RATES_LOADING'
export const MASTER_TRAYEK_UPDATE_RATES_SUCCESS = 'MASTER_TRAYEK_UPDATE_RATES_SUCCESS'